import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_SidebarItemLink = _resolveComponent("SidebarItemLink")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _directive_role = _resolveDirective("role")!

  return (_ctx.item.alwaysShow)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.theOnlyOneChild && !_ctx.theOnlyOneChild.children)
          ? (_openBlock(), _createBlock(_component_SidebarItemLink, {
              key: 0,
              to: _ctx.resolvePath(_ctx.theOnlyOneChild.path),
              name: _ctx.item.title
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, {
                  index: _ctx.resolvePath(_ctx.theOnlyOneChild.path)
                }, {
                  default: _withCtx(() => [
                    (_ctx.item.icon)
                      ? (_openBlock(), _createBlock(_component_svg_icon, {
                          key: 0,
                          iconname: _ctx.item.icon,
                          class: "common_mgr4 font18"
                        }, null, 8, ["iconname"]))
                      : _createCommentVNode("", true),
                    (_ctx.theOnlyOneChild.title)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.theOnlyOneChild.title), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["index"])
              ]),
              _: 1
            }, 8, ["to", "name"]))
          : (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 1,
              index: _ctx.resolvePath(_ctx.item.path)
            }, {
              title: _withCtx(() => [
                (_ctx.item.icon)
                  ? (_openBlock(), _createBlock(_component_svg_icon, {
                      key: 0,
                      iconname: _ctx.item.icon,
                      class: "common_mgr4 font18"
                    }, null, 8, ["iconname"]))
                  : _createCommentVNode("", true),
                (_ctx.item.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.item.title), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (child) => {
                  return (_openBlock(), _createBlock(_component_sidebar_item, {
                    key: child.path,
                    item: child,
                    "is-collapse": _ctx.isCollapse,
                    "is-first-level": false,
                    "base-path": _ctx.resolvePath(child.path)
                  }, null, 8, ["item", "is-collapse", "base-path"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["index"]))
      ], 512)), [
        [_directive_role, _ctx.item.role]
      ])
    : _createCommentVNode("", true)
}